
export function menuDropdown() {

    const navBar = document.querySelector('.navbar');
    const fixedHeader = document.querySelector('.fixed-header');

    if (navBar) {
        if (window.matchMedia("(min-width: 1200px)").matches) {

            let applyHeightSubMenu = () => {

                let navHeight = navBar.offsetHeight - 40;
                if( fixedHeader.classList.contains('sticky')){
                    navHeight = navBar.offsetHeight - 20 ;
                }
                const navBarCollapse = document.querySelectorAll('.navbar-collapse .sub-menu');
                if (navBarCollapse) {
                    navBarCollapse.forEach(function (item) {
                        // const subMenuHeight = item.offsetHeight;
                        const wrapperSubMenu = item.querySelector('.navbar-collapse .sub-menu ul');
                        wrapperSubMenu.style.paddingTop = navHeight + 'px';
                    });
                }
            }

            applyHeightSubMenu();


            // if (window.innerWidth > 992) {
            document.querySelectorAll('.navbar .nav-item').forEach(function (everyitem) {
                everyitem.addEventListener('mouseover', function () {
                    let elLink = this.querySelector('.menu-item-has-children > a');

                    applyHeightSubMenu();

                    if (elLink != null) {
                        let nextEl = elLink.nextElementSibling;
                        elLink.classList.add('show');
                        nextEl.classList.add('show');
                    }
                });

                everyitem.addEventListener('mouseleave', function () {
                    let elLink = this.querySelector('.menu-item-has-children > a');

                    if (elLink != null) {
                        let nextEl = elLink.nextElementSibling;
                        elLink.classList.remove('show');
                        nextEl.classList.remove('show');
                    }
                })
            });

        } else {
            // console.log('not match');
        }

    }
}
